// extracted by mini-css-extract-plugin
export default {"ListViewMetadata_0":"ListItemsHeaderWithoutBulkActions-module__ListViewMetadata_0--x0baS"};